import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { compose, withState } from 'recompose';
import { forms } from 'components';
import apiHOCs from 'components/apiHOCs';

import 'assets/screens.scss';
import './style.scss';

const AddProductScene = ({
  addProductApiHOC: {
    postProduct,
  },
  filtersListApiHOC: {
    allFilters,
  },
  isModalOpen,
  setModalOpen,
}) => (
	<div className="post-product-layout">
    <forms.AddProductForm
      submitAction={postProduct}
      onSubmitSuccess={() => setModalOpen(true)}
      filters={allFilters}
    />
    <Modal
      isOpen={isModalOpen}
      onAfterOpen={() => setTimeout(() => setModalOpen(false), 1500)}
      onRequestClose={() => setModalOpen(false)}
      ariaHideApp={false}
      style={{
        overlay: {
          zIndex: 1005,
          backgroundColor: 'rgba(0,0,0,0.5)',
        },
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          padding: '40px',
          overflow: 'none',
        },
      }}
    >
      <span>Продукт успешно добавлен</span>
    </Modal>
	</div>
);

AddProductScene.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  setModalOpen: PropTypes.func.isRequired,
  addProductApiHOC: PropTypes.shape({
    postProduct: PropTypes.func.isRequired,
  }).isRequired,
  filtersListApiHOC: PropTypes.shape({
    allFilters: PropTypes.object.isRequired,
  }).isRequired,
};

export default compose(
  withState('isModalOpen', 'setModalOpen', false),
  apiHOCs.AddProductApiHOC(),
  apiHOCs.FiltersListApiHOC(),
)(AddProductScene);



// WEBPACK FOOTER //
// ./src/scenes/AddProductScene/index.js